import { useLocation } from 'react-router-dom';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UILink from 'UIComponents/link/UILink';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import { isNewCatalogUser } from '../../utils/utils';
import styled from 'styled-components';
import { EERIE } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import UIImage from 'UIComponents/image/UIImage';
// @ts-expect-error Could not find a declaration file for module
import personImageUrlMobile from 'bender-url!../../../images/pngs/Jean_thumbnail.png';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useWizardProgress } from '../../features/wizard';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WizardActionsToolbar = styled(UIFlex).withConfig({
  displayName: "WizardActions__WizardActionsToolbar",
  componentId: "sc-8sztsi-0"
})(["padding:20px 40px;flex:0 0 72px;@media (max-width:", "){padding:20px 10px 0;flex:0 0 58px;}"], GRID_BREAKPOINT_SMALL);
const WizardBackButton = styled(UIBackButton).withConfig({
  displayName: "WizardActions__WizardBackButton",
  componentId: "sc-8sztsi-1"
})(["[data-icon-name='left']{font-size:22px !important;vertical-align:middle;margin-right:0 !important;}"]);
const WizardBackButtonText = styled(FormattedMessage).withConfig({
  displayName: "WizardActions__WizardBackButtonText",
  componentId: "sc-8sztsi-2"
})(["font-size:14px;"]);
export const WizardCloseButton = styled(UICloseButton).withConfig({
  displayName: "WizardActions__WizardCloseButton",
  componentId: "sc-8sztsi-3"
})(["position:initial;top:initial;right:initial;transform:translateY(-44px);@media (max-width:", "){width:20px;transform:translate(-1px,3px);}"], GRID_BREAKPOINT_SMALL);
const SideUIImage = styled(UIImage).withConfig({
  displayName: "WizardActions__SideUIImage",
  componentId: "sc-8sztsi-4"
})(["margin-top:-8px;"]);
export const ResultsLinkMessage = styled(FormattedMessage).withConfig({
  displayName: "WizardActions__ResultsLinkMessage",
  componentId: "sc-8sztsi-5"
})(["font-size:14px;"]);
const WizardActions = ({
  onBackLinkClick,
  onCancelClick,
  totalResultCount,
  catalogUrl
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const location = useLocation();
  const isNewUser = isNewCatalogUser(location.search);
  const trackCatalogLinkClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-view-results-on-catalog',
      location: 'results page header'
    });
  };
  const {
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const showBackButton = location.pathname !== WIZARD_URL_FRAGMENT;
  const showCloseButton = !isNewUser && !isFinalStep;
  const showResultsLink = isFinalStep && totalResultCount > 0;
  return /*#__PURE__*/_jsxs(WizardActionsToolbar, {
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      children: [showBackButton && /*#__PURE__*/_jsx(WizardBackButton, {
        onClick: onBackLinkClick,
        children: /*#__PURE__*/_jsx(UILink, {
          children: /*#__PURE__*/_jsx(WizardBackButtonText, {
            message: "learningCenter.wizard.modal.buttons.backlink"
          })
        })
      }), isMobile && !showBackButton && /*#__PURE__*/_jsx(SideUIImage, {
        src: personImageUrlMobile,
        width: 44
      })]
    }), showCloseButton && /*#__PURE__*/_jsx(WizardCloseButton, {
      color: EERIE,
      onClick: onCancelClick,
      size: 'large'
    }), showResultsLink && /*#__PURE__*/_jsx(UIRouterLink, {
      onClick: trackCatalogLinkClick,
      to: catalogUrl,
      children: /*#__PURE__*/_jsx(ResultsLinkMessage, {
        message: "learningCenter.wizard.modal.stepfinal.resultslink",
        options: {
          resultsCount: totalResultCount
        }
      })
    })]
  });
};
export default WizardActions;